const TransactionIndividualTable = ({ data }) => {
  const { referenceId, date, transactionType, amount, status } = data;
  return (
    <>
      <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">{referenceId}</div>
      <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">{date}</div>
      <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">{transactionType}</div>
      <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">{amount}</div>
      <div className="h-11 leading-[44px] border-b border-[#E9EAEC] text-[#02A443]">{status}</div>
    </>
  );
};

export default TransactionIndividualTable;
